var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExamFailed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-groups_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "groups_3",
    "data-name": "groups \\u2013 3",
    clipPath: "url(#clip-groups_3)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_208",
    "data-name": "Ellipse 208",
    cx: 255.5,
    cy: 255.5,
    r: 255.5,
    transform: "translate(1 1)",
    fill: "rgba(238,71,63,0.15)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_433",
    "data-name": "Group 433",
    transform: "translate(-4.557 -4.537)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_969",
    "data-name": "Rectangle 969",
    width: 49.854,
    height: 261.732,
    rx: 10,
    transform: "translate(185.809 370.861) rotate(-135)",
    fill: "#ee473f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_970",
    "data-name": "Rectangle 970",
    width: 49.854,
    height: 261.732,
    rx: 10,
    transform: "translate(150.561 185.809) rotate(-45)",
    fill: "#ee473f"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExamFailed);
export default __webpack_public_path__ + "static/media/exam-failed.6b70e74d.svg";
export { ForwardRef as ReactComponent };